import React from 'react'
import { Link } from 'react-router-dom';
import Slider from "react-slick";

const Combo = (props) => {

    const colorString = Object.values(props.theme).toString();
    
    var settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 3,
        dots:false,
        autoplay: true,
        nav:false,
        speed: 500,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode: false
              }
            }

          ]
    };
    return (
        <section className={colorString === 'true'?`customSec combo dark`: `customSec combo whiteTheme`}>
            <div className="container">
                <div className="scroller">
                    <div className="sectionHeading justify-content-center text-center">
                        <div className="d-block">
                            <h2>EXCLUSIVE COMBO PACKS</h2>
                            <h3>Get your hands on the exclusive NFT cards with multiple benefits.</h3>
                        </div>
                    </div>
                    <Slider {...settings}>
                        <div className="comboBx">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + '/images/trumpcard_COMBO_CASE_SAMPLE_BLACKNGOLD_gold.png'} alt="" />
                            </Link>
                            <div className="text-center mt-3">
                                <Link to="/" className="customBtn">Join waitlist</Link>
                            </div>
                        </div>
                        <div className="comboBx">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + '/images/trumpcard_COMBO_CASE_SAMPLE_blue_card.png'} alt="" />
                            </Link>
                            <div className="text-center mt-3">
                                <Link to="/" className="customBtn">Order Now</Link>
                            </div>
                        </div>
                        <div className="comboBx">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + '/images/trumpcard_COMBO_CASE_SAMPLE_BLACKNGOLD_black.png'} alt="" />
                                
                            </Link>
                            <div className="text-center mt-3">
                                <Link to="/" className="customBtn">Join waitlist</Link>
                            </div>
                        </div>

                        <div className="comboBx">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + '/images/trumpcard_COMBO_CASE_SAMPLE_BLACKNGOLD_gold.png'} alt="" />
                            </Link>
                            <div className="text-center mt-3">
                                <Link to="/" className="customBtn">Join waitlist</Link>
                            </div>
                        </div>
                        <div className="comboBx">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + '/images/trumpcard_COMBO_CASE_SAMPLE_blue_card.png'} alt="" />
                            </Link>
                            <div className="text-center mt-3">
                                <Link to="/" className="customBtn">Order Now</Link>
                            </div>
                        </div>
                        <div className="comboBx">
                            <Link to="/">
                                <img src={process.env.PUBLIC_URL + '/images/trumpcard_COMBO_CASE_SAMPLE_BLACKNGOLD_black.png'} alt="" />
                                
                            </Link>
                            <div className="text-center mt-3">
                                <Link to="/" className="customBtn">Join waitlist</Link>
                            </div>
                        </div>
                        
                    </Slider>
                </div>
            </div>
            <img src={process.env.PUBLIC_URL + '/images/rays.svg'} alt="" className="comboRays" />
        </section>
    )
}
export default Combo;